import { useCallback, useEffect, useState } from "react";
import { resizeImage, validateFile } from "../functions";
import { useMapa } from "../../../../../contexts/mapaContext";
// Hook personalizado para lógica de arquivos
const useFileManagement = (
  iconsElementNames,
  icon,
  sizeOutput,
  MAX_SIZE_MB_DEFAULT,
  sizeFull
) => {
  const { setSnackbar } = useMapa();
  const [files, setFiles] = useState([]);
  const [imgSelected, setImgSelected] = useState(null);

  const checkFileError = useCallback(
    (name) => {
      const cleanName = name?.trim()?.toLowerCase();
      const iconName = icon?.nome?.trim()?.toLowerCase();
      const response =
        cleanName?.startsWith("_") ||
        (cleanName !== iconName &&
          iconsElementNames?.some(
            (icon) => icon?.trim()?.toLowerCase() === cleanName
          ));
      return response;
    },

    [iconsElementNames, icon?.nome]
  );

  // Atualiza erro de cada arquivo
  useEffect(() => {
    setFiles((prev) =>
      prev.map((f) => ({
        ...f,
        error: checkFileError(f.name),
      }))
    );
  }, [iconsElementNames, checkFileError]);

  const handleFiles = useCallback(
    (fileList) => {
      const newFiles = Array.from(fileList).filter((file) =>
        validateFile(file)
      );

      newFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const imgSrc = e.target?.result;
          // agora resizeImage retorna { src, blob }
          const { src: resizedSrc, blob } = await resizeImage(
            imgSrc,
            sizeOutput
          );
          //se o tamnho da imagem somado ao tamanho atual for maior que o permitido, não adiciona

          const newSize = sizeFull + blob.size / 1024 / 1024;

          if (newSize >= MAX_SIZE_MB_DEFAULT) {
            setSnackbar({
              children: "Error: Tamanho máximo de arquivos excedido",
              severity: "error",
            });
            return;
          }

          // cria um novo File a partir do blob (substitui o file original)
          const newFileObj = new File([blob], file.name, { type: blob.type });

          setFiles((prev) => [
            ...prev,
            {
              src: resizedSrc,
              file: newFileObj, // <-- tamanho atualizado aqui
              name: file.name,
              error: checkFileError(file.name),
            },
          ]);
        };
        reader.readAsDataURL(file);
      });
    },
    [files.length, checkFileError, sizeOutput]
  );

  const removeFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  return {
    files,
    setFiles,
    imgSelected,
    setImgSelected,
    handleFiles,
    removeFile,
    checkFileError,
  };
};

// Hook personalizado para crop de imagem
const useImageCrop = (sizeOutput) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  const getCroppedImage = useCallback(
    (imageSrc, cropPixels, outputSize = sizeOutput) => {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = imageSrc;
        image.onload = () => {
          // Cria canvas com tamanho FIXO
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          const outputWidth = outputSize;
          const outputHeight = outputSize;
          canvas.width = outputWidth;
          canvas.height = outputHeight;
          const mimeType = imageSrc?.type || "image/png"; // Ex: "image/jpeg" ou "image/png"

          // Desenha a área recortada redimensionando para 200x200
          ctx.drawImage(
            image,
            cropPixels.x,
            cropPixels.y,
            cropPixels.width,
            cropPixels.height,
            0,
            0,
            outputWidth,
            outputHeight
          );

          resolve(canvas.toDataURL(mimeType));
        };
        image.onerror = reject;
      });
    },
    []
  );
  const resetCrop = useCallback(() => {
    setCrop({ x: 0, y: 0 });
    setZoom(1);
  }, []);

  return {
    crop,
    setCrop,
    zoom,
    setZoom,
    getCroppedImage,
    resetCrop,
  };
};

export { useFileManagement, useImageCrop };
